import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

function Login() {
  const [form, setForm] = useState({ email: '', password: '' });

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function handleSubmit(e) {
    e.preventDefault();
    alert(`Logging in with ${form.email}`);
  }

  const mainStyle = {
    padding: '60px 40px',
    minHeight: '500px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const formContainerStyle = {
    background: 'white',
    padding: '40px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    maxWidth: '450px',
    width: '100%',
  };

  const inputStyle = {
    display: 'block',
    width: '100%',
    padding: '12px',
    margin: '10px 0',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '14px',
  };

  const buttonStyle = {
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    border: 'none',
    padding: '12px 30px',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '16px',
    marginTop: '10px',
    width: '100%',
    fontWeight: '600',
  };

  return (
    <>
      <Navbar />
      <div style={mainStyle}>
        <div style={formContainerStyle}>
          <h1 style={{ marginBottom: '10px', textAlign: 'center' }}>Login</h1>
          <p style={{ textAlign: 'center', color: '#666', marginBottom: '30px' }}>
            Welcome back to Broadway Holidays
          </p>

          <form onSubmit={handleSubmit}>
            <input
              style={inputStyle}
              type="email"
              name="email"
              placeholder="Email"
              value={form.email}
              onChange={handleChange}
              required
            />
            <input
              style={inputStyle}
              type="password"
              name="password"
              placeholder="Password"
              value={form.password}
              onChange={handleChange}
              required
            />
            <button style={buttonStyle} type="submit">
              Login
            </button>
          </form>

          <p style={{ textAlign: 'center', marginTop: '20px', color: '#666' }}>
            Don't have an account?{' '}
            <Link to="/register" style={{ color: '#667eea', fontWeight: '600' }}>
              Register here
            </Link>
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Login;
